import { Chip as ChipBase, type ChipProps } from '@shared/ui-components/chip/chip';

import { withCustomLinkComponent } from '../../i18n/with-custom-link-component';

export const Chip = (props: Omit<ChipProps, 'LinkComponent'>) =>
  withCustomLinkComponent(ChipBase, props);
